import { GetLangParams } from '@jsverse/transloco-persist-lang';
import { availableLocaleCodes } from '@locale/config/available-locale-codes';

/**
 * Resolves a single candidate (e.g. 'en-GB', 'en') to a supported locale code.
 * Matches an exact code first, then falls back to any regional variant of the
 * same language (a bare 'en' resolves to the first registered 'en-*' code).
 * Returns undefined when the candidate is empty or unsupported.
 */
export const resolveLocale = (lang: string | null | undefined): string | undefined => {
  if (!lang) {
    return undefined;
  }
  return availableLocaleCodes.find((code) => code === lang || code.startsWith(`${lang}-`));
};

/**
 * Picks the active locale from the available candidates, most specific first:
 * the cached lang, then the full browser culture (e.g. 'en-GB'), then the bare
 * browser language (e.g. 'en'), and finally the default. Ordering culture before
 * the bare language keeps 'en-GB' from being collapsed to the first 'en-*' code.
 */
export const resolveActiveLocale = ({ cachedLang, browserLang, cultureLang, defaultLang }: GetLangParams): string =>
  resolveLocale(cachedLang) ?? resolveLocale(cultureLang) ?? resolveLocale(browserLang) ?? defaultLang;
